import axios from "axios";

/**
 * Project credentials go only to the configured API origin: axios's default base, which the
 * platform sets at bootstrap (`bootstrap.apiOrigin`), or the page's own origin on plain web.
 * Never to the origin a request's own `baseURL` names: any caller can set that, and a fence that
 * took its allowed origin from the request would admit whatever origin the request chose.
 * Both transports check here, each with the URL it actually sends: the axios interceptor in
 * `config/axios.ts` with axios's own resolution (`axios.getUri`: a request whose
 * `allowAbsoluteUrls` is false goes to its `baseURL` even when its `url` is absolute), and
 * `authenticatedFetch` with its URL against the configured base, which is where the native
 * shell's `fetch` sends an `/api/` path.
 */
export function assertApiOrigin(target: URL): void {
    const configured = new URL(
        axios.defaults.baseURL || window.location.origin,
        window.location.origin,
    );
    if (target.origin !== configured.origin)
        throw new Error("Cross-origin project credentials are forbidden");
}
